import type { LooseAdfNode } from './types';

export const asLooseNode = (node: unknown): LooseAdfNode => node as LooseAdfNode;
